/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/function-component-definition */
import React, { FC, ReactNode } from 'react';

import { styled } from '@mui/system';
import color from '../../styles/color';

const Table = styled('div')`
  box-sizing: border-box;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
`;
const TdStyle = styled('div')<{ flexDirection?: string }>`
  box-sizing: border-box;
  border-right: 1px solid #dee2e6;
  flex: 1;
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  align-items: center;
  padding: 0px 12px;
  flex-basis: 0;
  :last-child {
    border: none;
  }
  div {
  }
`;

const TdTable = styled('div')`
  box-sizing: border-box;
  border-right: 1px solid #dee2e6;
  flex: 1;
  flex-direction: column;
  display: flex;
  align-items: center;
  margin: 0 -12px;

  :last-child {
    border: none;
  }
`;
const Tr = styled('div')`
  box-sizing: border-box;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  min-height: 54px;
  width: 100%;
  :hover {
    background-color: ${color.gray00};
  }
  :last-child {
    border: none;
  }
`;

const ThStyle = styled(TdStyle)`
  box-sizing: border-box;
  border-right: 1px solid #dee2e6;
  flex: 1;
  background-color: ${color.gray00};
  display: flex;
  align-items: center;
  padding: 0px 12px;
  flex-basis: 0;

  :last-child {
    border: none;
  }
`;
const Td: FC<{
  flexDirection?: string;
  children: ReactNode;
  style?: any;
  width?: string;
  onClick?: () => void;
}> = (props) => {
  const { flexDirection, children, style, width } = props;
  return (
    <TdStyle
      {...props}
      flexDirection={flexDirection}
      style={{ ...style, width, flex: width ? 'unset' : '1' }}
    >
      {children}
    </TdStyle>
  );
};
const Th: FC<{ children: ReactNode; style?: any; width?: string }> = ({
  children,
  style,
  width,
}) => {
  return (
    <ThStyle style={{ ...style, width, flex: width ? 'unset' : '1' }}>
      {children}
    </ThStyle>
  );
};

export { Table, Tr, Th, Td, TdTable };
